import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, map, of, take, tap } from 'rxjs';
import { SessionService } from '../services/session/session.service';
import { Client } from '../models/client';
import { Store, select } from '@ngrx/store';

import * as DesignToolActions from '@core/state/design-tool/design-tool.actions';
import * as fromDesignTool from '@core/state/design-tool/design-tool.selectors';

@Injectable({
  providedIn: 'root'
})
export class GetDesignFilesResolver  {
  client: Client;

  constructor(
    private sessionService: SessionService,
    private store: Store
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.client = this.sessionService.getActiveClient();
    this.store.dispatch( DesignToolActions.getDesignLibrary({ client: this.client }));

     // Wait for the designs to be loaded in the store
     return this.store.pipe(
      select(fromDesignTool.selectDesignLibrary),
      take(1), // Take the first response from the store
      map(() => true) // Always resolve to true as we are only waiting for the data (or lack thereof) to be loaded
  );
}
}
